import {Typography, Link} from '@mui/material'

export const ReturnPolicy = () => {
  return (
    <>
      <Typography paragraph>
        We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.
      </Typography>

      <Typography paragraph>
        <strong>Where we ship.</strong> Most items ship domestically within the United States only. Certain items are also available for international delivery, including to the European Union. Those items are marked <strong>"international shipping available"</strong> on their product page. If an item is not marked that way, we can only ship it to a US address.
      </Typography>

      <Typography paragraph>
        To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You'll also need the receipt or proof of purchase.
      </Typography>

      <Typography paragraph>
        To start a return, you can contact us at{' '}
        <Link href="mailto:info@miamigooners.com">info@miamigooners.com</Link>. Please note that returns will need to be sent to the following address: 2852 SW 35th Ave, Miami, FL 33133
      </Typography>

      <Typography paragraph>
        If your return is accepted, we'll send you a return shipping label, as well as instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted.
      </Typography>

      <Typography paragraph>
        You can always contact us for any return question at{' '}
        <Link href="mailto:info@miamigooners.com">info@miamigooners.com</Link>.
      </Typography>

      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop: 3}}>
        Damages and issues
      </Typography>
      <Typography paragraph>
        Please inspect your order upon reception and contact us immediately if the item is defective, damaged or if you receive the wrong item, so that we can evaluate the issue and make it right.
      </Typography>

      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop: 3}}>
        Exceptions / non-returnable items
      </Typography>
      <Typography paragraph>
        Certain types of items cannot be returned, like perishable goods (such as food, flowers, or plants), custom products (such as special orders or personalized items), and personal care goods (such as beauty products). We also do not accept returns for hazardous materials, flammable liquids, or gases. Please get in touch if you have questions or concerns about your specific item.
      </Typography>
      <Typography paragraph>
        Unfortunately, we cannot accept returns on sale items or gift cards.
      </Typography>

      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop: 3}}>
        Exchanges
      </Typography>
      <Typography paragraph>
        The fastest way to ensure you get what you want is to return the item you have, and once the return is accepted, make a separate purchase for the new item.
      </Typography>

      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop: 3}}>
        European Union 14 day cooling off period
      </Typography>
      <Typography paragraph>
        This applies only to the items we offer for international delivery, which are marked "international shipping available" on their product page. We do not ship other items into the European Union. Where merchandise is being shipped into the European Union, you have the right to cancel or return your order within 14 days, for any reason and without a justification. As above, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You'll also need the receipt or proof of purchase.
      </Typography>

      <Typography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop: 3}}>
        Refunds
      </Typography>
      <Typography paragraph>
        We will notify you once we've received and inspected your return, and let you know if the refund was approved or not. If approved, you'll be automatically refunded on your original payment method within 10 business days. Please remember it can take some time for your bank or credit card company to process and post the refund too.
      </Typography>
      <Typography paragraph>
        If more than 15 business days have passed since we've approved your return, please contact us at{' '}
        <Link href="mailto:info@miamigooners.com">info@miamigooners.com</Link>.
      </Typography>
    </>
  )
}
